import { __rest } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { useAutocompleteContext } from '../../state/autocomplete-context.js';
import Tag from '../../../../components/tag/tag.js';

function ComboboxTags(_ref) {
  let {
    id,
    selectedOptions: selectedOptionsProp = [],
    limitSelectedOptions,
    tagProps,
    expanded,
    disabled
  } = _ref;
  if (selectedOptionsProp === undefined || selectedOptionsProp.length === 0) {
    return null;
  }
  const autocompleteContext = useAutocompleteContext();
  const {
    dispatch
  } = autocompleteContext ? Object.assign({}, autocompleteContext) : {};
  const selectedOptions = expanded ? selectedOptionsProp : selectedOptionsProp.slice(0, limitSelectedOptions);
  const moreTagsCounter = selectedOptionsProp.length - selectedOptions.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, selectedOptions.map(option => {
    // separates closeProps from the rest
    const _a = tagProps ? tagProps(option) : {},
      {
        renderTag,
        closeProps
      } = _a,
      rest = __rest(_a, ["renderTag", "closeProps"]);
    // separates onClick and onMouseDown from the closeProps rest so we can call them separately
    const _b = closeProps || {},
      {
        onClick: onCloseClickProp,
        onMouseDown: onCloseMouseDownProp,
        label
      } = _b,
      tagCloseProps = __rest(_b, ["onClick", "onMouseDown", "label"]);
    return /*#__PURE__*/React.createElement(Tag, Object.assign({
      key: option.value,
      display: "outlined",
      small: true
    }, rest, {
      closeProps: Object.assign({
        label: label || "Remove ".concat(option.title),
        disabled: disabled,
        onMouseDown: event => {
          onCloseMouseDownProp === null || onCloseMouseDownProp === void 0 ? void 0 : onCloseMouseDownProp(event);
          if (!event.preventHCREventHandling) {
            // prevents focus from being triggered
            event.preventDefault();
          }
        },
        onClick: event => {
          onCloseClickProp === null || onCloseClickProp === void 0 ? void 0 : onCloseClickProp(event);
          if (dispatch && !event.preventHCREventHandling) {
            dispatch({
              type: 'REMOVE_OPTION',
              option,
              latestEvent: event
            });
          }
        }
      }, tagCloseProps)
    }), /*#__PURE__*/React.createElement("span", {
      id: "".concat(id, "-").concat(option.value)
    }, renderTag ? renderTag(option) : option.title));
  }), moreTagsCounter > 0 && (/*#__PURE__*/React.createElement(Tag, {
    display: "outlined",
    small: true
  }, "+", moreTagsCounter)));
}
ComboboxTags.displayName = 'ComboboxTags';

export { ComboboxTags };
